var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 8,
    viewBox: "0 0 36 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#013198",
    d: "M9 0c2.21 0 4 1.79 4 4s-1.79 4-4 4C7.136 8 5.57 6.726 5.126 5H0V3h5.126C5.57 1.275 7.136 0 9 0zm18 0c1.864 0 3.43 1.275 3.874 3H36v2h-5.126c-.445 1.726-2.01 3-3.874 3-2.21 0-4-1.79-4-4s1.79-4 4-4zm0 2c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zM15 3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm3 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteFound);
export default __webpack_public_path__ + "static/media/route-found.c6fa8bb66b88dee12638e15a433a9a9e.svg";
export { ForwardRef as ReactComponent };